import expertXltMixin from 'mixins/xlt/expertXltMixin.js'

export default {
  mixins: [expertXltMixin],
  created() {
    if (this.mixinTabList.length && this.tbmHasService) {
      this.mixinHighLightFirstTab()
    }
  },
  methods: {
    // 如果有服务tab，就直接激活服务tab；否则要等列表接口都调完后才能确定激活哪个
    mixinHighLightFirstTab() {
      if (!Object.keys(this.tbmCurrentTab).length) {
        const first = this.mixinTabList[0]
        this.$store.commit('homepage/SET_CURRENT_TAB', first)
      }
    }
  },
  computed: {
    tbmCurrentTab() {
      return this.$store.state.homepage.currentTab
    },
    // 当前url访问的是否咨询师
    tbmIsConsultTeacher() {
      return this.$store.getters['homepage/isConsultTeacher']
    },
    // 当前url访问的是否倾听师
    tbmIsQingsuTeacher() {
      return this.$store.getters['homepage/isQingtingTeacher']
    },
    qingsuService() {
      return this.$store.state.homepage.qingsuService
    },
    // 有没有服务
    tbmHasService() {
      return this.$store.getters['homepage/hasService']
    },
    // 是否显示评价tab
    isRateTab() {
      return this.$store.state.homepage.isRateTab
    },
    // 是否显示动态tab
    isDynamicTab() {
      let list = this.$store.getters['homepage/getDynamicListData'] || []
      return list.length > 0
    },
    // 是否显示问答tab
    isqaTab() {
      let list = this.$store.getters['homepage/getTabListData']('qa') || []
      return list.length > 0
    },
    // 是否显示FMtab
    isFMTab() {
      let list = this.$store.getters['homepage/getTabListData']('fm') || []
      return list.length > 0
    },
    // 是否显示文章tab
    isArticleTab() {
      let list = this.$store.getters['homepage/getTabListData']('article') || []
      return list.length > 0
    },
    // 是否显示故事tab
    isStoryTab() {
      let list = this.$store.getters['homepage/getTabListData']('story') || []
      return list.length > 0
    },
    tabRateNum() {
      return this.$store.getters['homepage/getTabRateNum']
    },
    mixinTabList() {
      let consultItem = null
      let qingsuItem = null
      if (this.tbmHasService) {
        consultItem = {
          name: 'service',
          title: this.tbmIsConsultTeacher ? '咨询' : '服务'
        }
      }
      if (this.tbmIsQingsuTeacher) {
        qingsuItem = {
          name: 'qingsu',
          title: '倾诉'
        }
      }
      let list = [
        consultItem,
        qingsuItem,
        this.isDynamicTab
          ? {
              name: 'dynamic',
              title: '动态'
            }
          : null,
        this.isqaTab
          ? {
              name: 'qa',
              title: '问答'
            }
          : null,
        this.isFMTab
          ? {
              name: 'fm',
              title: 'FM'
            }
          : null,
        this.isArticleTab
          ? {
              name: 'article',
              title: '文章'
            }
          : null,
        (this.tbmIsConsultTeacher || this.tbmIsQingsuTeacher) && this.isRateTab
          ? {
              name: 'evaluate',
              title: '评价',
              rateNum: this.tabRateNum
            }
          : null,
        this.isStoryTab
          ? {
              name: 'story',
              title: '故事'
            }
          : null
      ]

      list = list.filter(item => !!item)
      // 有些tab不能在心乐土咨询师页面展示
      if (this.mixinShowStudioInfo) {
        const notInXlt = ['dynamic', 'qa', 'fm', 'article', 'story']
        list = list.filter(item => !notInXlt.includes(item.name))
      }

      return list
    }
  }
}
